import { ArrivalCard } from "../../ArrivalCard";
import { useTranslation } from "react-i18next";
import { Button, Row } from "react-bootstrap";
import { AntPagination } from "@/Component/AntPagination/AntPagination";
import { useState } from "react";
import { useConfirm } from "@/utils/hooks/useConfrim";
import { SearchFilter } from "@/CommonElements/SearchFilter/SearchFilter";
import ActionDropdown from "@/CommonElements/ActionDropdown";
import { Empty, Radio, Space } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import { HajiIcon, JobLinkIcon, PrinterIcon, ViewIcon } from "@hugeicons/core-free-icons/index";
import { useReceptionCenter } from "../useReceptionCenter";
import { filterObject } from "@/utils/helpers";
import { useReceptionCenterSideEffect } from "./hooks/useReceptionCenterSideEffect";
import { toast } from "react-toastify";
import { useSystem } from "@/utils/hooks/useLocation";
import { SYSTEMS } from "@/utils/permissions";
import { AccommodatePilgrimsModal } from "../AccommodatePilgrims";
import { ManifestPilgrimsModal } from "../ManifestPilgrims";
import { AssignBagNumberToManifestModal } from "../AssignBagNumberToManifest";


export const FormPortsTab = () => {
    const [arrival, setArrival] = useState(null);
    const [showManifestPilgrimsModal, setShowManifestPilgrimsModal] = useState(false);
    const [showAssignBagNumberToManifestModal, setShowAssignBagNumberToManifestModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [{ count: totalCount, ...filters }, setFilters] = useState({});
    const { t } = useTranslation();
    const { labelValues, isBetweenCities, isFromPorts, setCurrentDate, currentDate, cardLabelValues, filterFields } = useReceptionCenter();
    const { confirm, ModalComponent } = useConfirm();
    const [showAccommodatePilgrimsModal, setShowAccommodatePilgrimsModal] = useState(false);

    const { currentSystem } = useSystem()


    // =================
    // Side Effects
    // =================
    const { data, meta, cancelMutation, unassignMutation, downloadMadinaTafweejManifestMutation, completeMutation, loading, isPending } = useReceptionCenterSideEffect({
        queryParams: {
            page: currentPage,
            per_page: 10,
            ...filters,
        },
        isBetweenCities,
        isFromPorts,
    })


    const handleOkCancelMadinaManifest = ({ closeModal, id }) => {
        cancelMutation({ id }, {
            onSuccess: () => {
                closeModal();
            },
        });

        return false;
    };

    const handleOk = ({ closeModal, id }) => {
        completeMutation({ id }, {
            onSuccess: () => {
                closeModal();
            },
        });

        return false;
    };



    const handleCancelMadinaManifest = ({ id }) => {
        confirm({
            title: t("CONFIRM_CANCEL_MADINAH_MANIFEST_TITLE"),
            content: t("CONFIRM_CANCEL_MADINAH_MANIFEST_MESSAGE"),
            okText: t("CONFIRM"),
            cancelText: t("CANCEL"),
            onOk: (props) => handleOkCancelMadinaManifest({ ...props, id }),
        });
    };

    const handleCompleteMadinaManifest = ({ id }) => {
        confirm({
            title: t("CONFIRM_COMPLETE_MADINAH_MANIFEST_TITLE"),
            content: t("CONFIRM_COMPLETE_MADINAH_MANIFEST_MESSAGE"),
            okText: t("CONFIRM"),
            cancelText: t("CANCEL"),
            onOk: (props) => handleOk({ ...props, id }),
        });
    };

    const createActions = (item) => {
        if (currentSystem !== SYSTEMS.MADINA.code) {
            return null;
        }
        const id = item?.manifest_id || item?.tdm_id;
        if (!!item?.arrive_time) {
            return (
                <Button
                    onClick={() => handleCancelMadinaManifest({ id })}
                    className="btn btn-danger flex-fill">
                    {t("CANCEL_ARRIVAL")}
                </Button>
            );
        }

        return (
            <Button
                onClick={() => handleCompleteMadinaManifest({ id })}
                className="btn btn-primary flex-fill">
                {t("COMPLETE_ARRIVAL")}
            </Button>
        );
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDebouncedChange = (searchValue) => {
        setFilters(searchValue);
        setCurrentPage(1);
    };

    const arrivalRequestActions = (arrival) => {
        const id = arrival?.manifest_id || arrival?.tdm_id;

        return [
            {
                label: <Space role="button"
                    onClick={() => {
                        setArrival(arrival);
                        setShowManifestPilgrimsModal(true);
                    }}>
                    <HugeiconsIcon className="d-block" size={16} icon={ViewIcon} />
                    {t("VIEW_PASSENGER_DATA")}
                </Space>
            },
            // assign bag number
            !arrival.bag_no && currentSystem === SYSTEMS.MADINA.code && {
                label:
                    <Space role="button"
                        onClick={() => {
                            setArrival(arrival);
                            setShowAssignBagNumberToManifestModal(true);
                        }}>
                        <HugeiconsIcon className="d-block" size={16} icon={JobLinkIcon} />
                        {t("CREATE_AND_ASSIGN_BAG")}
                    </Space>,
            },
            // unassign bag number
            !!arrival.bag_no && currentSystem === SYSTEMS.MADINA.code && {
                label:
                    <Space>
                        <HugeiconsIcon className="d-block" size={16} icon={JobLinkIcon} />
                        {t("UNASSIGN_BAG")}
                    </Space>,
                onClick: () => {
                    confirm({
                        title: t("CONFIRM"),
                        content: t("CONFIRM_UNASSIGN_BAG_MESSAGE"),
                        okText: t("CONFIRM"),
                        cancelText: t("CANCEL"),
                        onOk: ({ closeModal }) => {
                            unassignMutation({ id, bag_no: arrival.bag_no }, {
                                onSuccess: () => {
                                    closeModal();
                                },
                            })
                            return false;
                        },
                    })
                },
                danger: true,
            },
            // accommodate pilgrims
            currentSystem === SYSTEMS.MADINA.code && {
                label:
                    <Space role="button"
                        onClick={() => {
                            setArrival(arrival);
                            setShowAccommodatePilgrimsModal(true);
                        }}>
                        <HugeiconsIcon className="d-block" size={16} icon={HajiIcon} />
                        {t("ACCOMMODATE_PILGRIMS")}
                    </Space>,
                disabled: !arrival.bag_no,
            },
            {
                label:
                    <Space>
                        <HugeiconsIcon className="d-block" size={16} icon={PrinterIcon} />
                        {t("DOWNLOAD_BAG")}
                    </Space>,
                onClick: () => {
                    const toastId = toast.loading(t("DOWNLOADING_BAG"));
                    downloadMadinaTafweejManifestMutation({ id: arrival.bag_no }, {
                        onSuccess: () => {
                            toast.update(toastId, {
                                render: t("DOWNLOAD_BAG_SUCCESSFULLY"),
                                type: 'success',
                                isLoading: false,
                                autoClose: 3000,
                            });

                        },
                        onError: (response) => {
                            toast.update(toastId, {
                                render: response?.response?.data?.message || t("DOWNLOAD_BAG_FAILED"),
                                type: 'error',
                                isLoading: false,
                                autoClose: 3000,
                            });
                        },
                    })
                },
                disabled: !arrival.bag_no,
            },
        ].filter(Boolean)
    };


    const hasFilter = filterObject(filters).length > 0;
    const scalationItems = loading ? Array.from({ length: 10 }, (_, index) => ({ id: index, loading: true })) : data;

    return (
        <div>
            <ModalComponent loading={isPending} />
            <Radio.Group
                disabled={loading}
                className="mb-3"
                onChange={(e) => setCurrentDate(e.target.value)}
                value={currentDate}
                options={[
                    { label: t("TODAY"), value: "today" },
                    { label: t("ALL"), value: "all" },
                ]}
            />
            <div className="flex-fill mb-3">
                <SearchFilter
                    filterFields={filterFields}
                    onChange={handleDebouncedChange}
                    debounced
                />
            </div>

            {!data.length && !loading && (hasFilter ? (
                <Empty description={t("NO_FILTER_RESULTS")} />
            ) : (
                <Empty />
            ))}

            <Row>
                {
                    scalationItems.map((manifest) => (
                        <ArrivalCard
                            actions={createActions(manifest)}
                            loading={manifest.loading || false}
                            key={manifest.id}
                            title={cardLabelValues.title}
                            titleValue={manifest[cardLabelValues.titleValueKey] || "-"}
                            renderActions={() => (
                                <ActionDropdown
                                    removeContainer={true}
                                    disabled={isPending}
                                    items={arrivalRequestActions(manifest)}
                                    iconAlign="vertical"
                                    buttonClassName="outline btn-icon btn-xs"
                                />
                            )}
                            arrival={manifest} labelValues={labelValues} />
                    ))
                }
            </Row>

            <AntPagination
                className="sticky-bottom z-1 w-100 p-3 bg-white"
                hideOnSinglePage
                pageSize={10}
                current={currentPage}
                onChange={handlePageChange}
                total={meta?.total || 0}
                showSizeChanger={false}
            />

            {showAccommodatePilgrimsModal && <AccommodatePilgrimsModal arrival={arrival} show={showAccommodatePilgrimsModal} onClose={() => setShowAccommodatePilgrimsModal(false)} />}
            {showManifestPilgrimsModal && <ManifestPilgrimsModal arrival={arrival} show={showManifestPilgrimsModal} onClose={() => setShowManifestPilgrimsModal(false)} />}
            {showAssignBagNumberToManifestModal && <AssignBagNumberToManifestModal arrival={arrival} show={showAssignBagNumberToManifestModal} onClose={() => setShowAssignBagNumberToManifestModal(false)} />}
        </div>
    );
};




